import React, { Component } from "react";
import { SingleDatePicker } from "react-dates";
import PropTypes from "prop-types";
import moment from "moment";
import omit from "lodash/omit";

class SingleDatePickerWrapper extends Component {
  constructor(props) {
    super(props);
    let focused = false;
    if (props.autoFocus) {
      focused = true;
    }
    this.state = {
      focused,
      date: props.initialDate
    };
  }

  onFocusChange = ({ focused }) => this.setState({ focused });

  onDateChange = date => {
    if (!(date === this.state.date)) {
      this.setState({ date });
    }
  };

  onClose = () => {
    setTimeout(() => {
      const { date } = this.state;
      const { onDateChangeFunction } = this.props;
      if (date) {
        onDateChangeFunction(date);
      }
      this.setState({ focused: false });
    }, 30);
  };

  returnYears = () => {
    const years = [];
    for (let i = moment().year() - 100; i <= moment().year(); i++) {
      years.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return years;
  };

  renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div>
        <select value={month.month()} onChange={e => onMonthSelect(month, e.target.value)}>
          {moment.months().map((label, value) => (
            <option key={label} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <select value={month.year()} onChange={e => onYearSelect(month, e.target.value)}>
          {this.returnYears()}
        </select>
      </div>
    </div>
  );

  render() {
    const { date, focused } = this.state;
    const props = omit(this.props, ["autoFocus", "onDateChangeFunction", "initialDate"]);

    return (
      <div>
        <SingleDatePicker
          {...props}
          date={date} // momentPropTypes.momentObj or null
          onDateChange={this.onDateChange} // PropTypes.func.isRequired
          renderMonthElement={this.renderMonthElement}
          numberOfMonths={1}
          focused={focused} // PropTypes.bool
          id="your_unique_id" // PropTypes.string.isRequired,
          onFocusChange={this.onFocusChange}
          onClose={this.onClose}
        />
      </div>
    );
  }
}

SingleDatePickerWrapper.propTypes = {
  onDateChangeFunction: PropTypes.func.isRequired,
  // eslint-disable-next-line react/require-default-props
  autoFocus: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  initialDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired
};

export default SingleDatePickerWrapper;
